import Spinner from '@/ui/Spinner';
// Стили
import './PageLoader.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var PageLoader = function PageLoader() {
    return /*#__PURE__*/ _jsx("div", {
        className: "page-loader",
        role: "status",
        "aria-live": "polite",
        children: /*#__PURE__*/ _jsx(Spinner, {
            size: "lg"
        })
    });
};
export default PageLoader;
